<template>
  <div
    class="form-modal animated"
    :class="{'fadeOut':!open}"
  >
    <transition
      name="form-animation"
      enter-active-class="animated zoomInUp"
      leave-active-class="animated zoomOutDown"
    >
      <div
        class="modal-box"
        v-if="open"
      >
        <header>
          <div class="logo">
            <h2 v-if="modalTitle">{{ modalTitle }}</h2>
            <img
              :src="logo"
              alt=""
              v-else
            >
          </div>
          <button
            class="btn btn-close"
            @click="onClose"
          >
            <i class="icon-close"/>
          </button>
        </header>
        <main :class="{'hasFooter':hasFooter}">
          <slot/>
        </main>
        <footer v-if="hasFooter">
          <div class="row">
            <div
              class="col"
              v-if="!hideSecondaryButton"
            >
              <button
                class="btn btn-primary btn-block"
                @click="$emit('secondaryButtonClick')"
              >{{ secondaryButtonLabel }}
              </button>
            </div>
            <div
              class="col"
              v-if="!hidePrimaryButton"
            >
              <el-button
                type="primary"
                @click="$emit('primaryButtonClick')"
              >{{ primaryButtonLabel }}
              </el-button>
            </div>
          </div>
        </footer>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FormModal',
  props: {
    primaryButtonLabel: {
      type: String,
      required: false,
      default: 'Aceptar'
    },
    secondaryButtonLabel: {
      type: String,
      required: false,
      default: 'Cancelar'
    },
    hidePrimaryButton: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSecondaryButton: {
      type: Boolean,
      required: false,
      default: false
    },
    modalTitle: {
      type: String,
      required: false,
      default: 'Título de Modal'
    }
  },
  data () {
    return {
      logo: process.env.LOGO,
      open: false
    }
  },
  computed: {
    hasFooter () {
      return !this.hideSecondaryButton || !this.hidePrimaryButton
    }
  },
  mounted () {
    this.open = true
  },
  methods: {
    onClose () {
      this.open = false
      setTimeout(() => {
        this.$emit('closeModal')
      }, 1000)
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
$primary-color: $color-ui-primary;

.form-modal {
  width: 100vw;
  height: 100vh;
  background-color: transparentize($color: white, $amount: 0.1);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 2000;

  * {
    @include font-primary();
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
  }

  .modal-box {
    animation-duration: 500ms;
    max-width: 500px;
    max-height: 90vh;
    overflow: hidden;
    display: block;
    position: relative;
    background-color: #fff;
    border: 1px solid #dddddd;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    header {
      position: relative;
      border-bottom: 1px solid #dddddd;
      height: 60px;
      overflow: hidden;
      .logo {
        float: left;
        img {
          margin: 14px;
          height: 30px;
        }
        h2 {
          line-height: 60px;
          font-size: 20px;
          color: $color-font-primary;
          font-weight: 500;
          padding-left: 20px;
        }
      }
      .btn-close {
        width: 60px;
        height: 60px;
        float: right;
        background-color: transparent;
        border-radius: 0;
        padding: 0;
        i {
          color: #999999;
          font-size: 25px;
        }
      }
    }
    main {
      clear: both;
      max-height: calc(90vh - 60px);
      overflow: auto;
      &.hasFooter {
        max-height: calc(90vh - 140px);
      }
    }
    footer {
      padding: 20px;
    }
  }
  .btn {
    height: 50px;
    padding: 0 20px;
    border: none;
    &.btn-primary {
      background-color: $primary-color;
      font-size: 14px;
      font-weight: 400;
    }
    &.btn-block {
      display: block;
    }
  }

  h1 {
    font-size: 20px;
    color: $color-font-primary;
    font-weight: normal;
  }

  @media (min-width: 0px) {
    /* smartphones, iPhone, portrait 480x320 phones */
    .modal-box {
      width: 100vw;
      max-width: 100vw;
      max-height: 100vh;
      height: 100vh;
      main {
        min-height: auto;
      }
    }
  }
  @media (min-width: 481px) {
    /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
  }
  @media (min-width: 641px) {
    /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
    .modal-box {
      max-width: 500px;
      max-height: 90vh;
      height: auto;
      main {
        min-height: auto;
        max-height: calc(90vh - 140px);
      }
    }
  }
  @media (min-width: 961px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
  }
  @media (min-width: 1025px) {
    /* big landscape tablets, laptops, and desktops */
  }
  @media (min-width: 1281px) {
    /* hi-res laptops and desktops */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_shared/form-modal.vue